import { render, staticRenderFns } from "./GroupPreviewModal.vue?vue&type=template&id=850337b2&scoped=true"
import script from "./GroupPreviewModal.vue?vue&type=script&lang=ts"
export * from "./GroupPreviewModal.vue?vue&type=script&lang=ts"
import style0 from "./GroupPreviewModal.vue?vue&type=style&index=0&id=850337b2&prod&lang=scss&scoped=true"
import style1 from "./GroupPreviewModal.vue?vue&type=style&index=1&id=850337b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850337b2",
  null
  
)

export default component.exports